import Spinner from "../../../Components/spinner";
import CustomPagination from "../../../helper/Pagination";
import {
 ActionButton,
 ToggleSwitch,
} from "../../../helper/ImageFormat";
import dateformate from "../../../helper/DateFormate";
const HandlerTable = ({
 loading,
 currencies,
 currentPage,
 perPage,
 handleEditClick,
 handleDelete,
 handleStatusToggle,
 totalCount,
 totalPages,
 handlePageClick,
}) => {
 

 return (
  <div className="row ">
   <div className="col-md-12 grid-margin stretch-card">
    <div className="card">
     <div className="card-body">
      <div className="table-responsive">
       <table
        className=" custom-table table table-striped"
        id="myTable"
        style={{ marginTop: "3px" }}
       >
        <thead>
         <tr>
          <th>User name</th>
          <th>Email</th>
          <th>Role</th>
          <th>Updated At</th>
          <th>Is Active</th>
          <th>Action</th>
         </tr>
        </thead>
        <tbody>
         {loading ? (
          <tr>
           <td colSpan="7" className="text-center">
            <Spinner />
           </td>
          </tr>
         ) : currencies.length > 0 ? (
          currencies?.map((data, id) => (
           <tr key={data.id}>
            <td>{data?.userName}</td>
            <td>{data?.email}</td>
             <td>{data?.role?.name}</td>
             <td>{dateformate(data.updatedAt)}</td>
           
            <td>
             <ToggleSwitch
              data={data}
              name="isActive"
              checked={data.isActive}
              handleStatusToggle={handleStatusToggle}
             module={"Users"}
             />
            </td>
            <td>
             <ActionButton
              data={data}
              handleEditClick={handleEditClick}
              handleDelete={handleDelete}
              module={"Users"}

             />
            </td>
           </tr>
          ))
         ) : (
          <tr>
           <td colSpan="7" className="text-center">
            <h4>No data available</h4>
           </td>
          </tr>
         )}
        </tbody>
       </table>
      </div>
      {currencies?.length > 0 && (
       <div>
        <CustomPagination
         currentPage={currentPage}
         totalPages={totalPages}
         onPageChange={handlePageClick}
         perPage={perPage}
         totalCount={totalCount}
        />
       </div>
      )}
     </div>
    </div>
   </div>
  </div>
 );
};

export default HandlerTable;
